import { tv } from "@fanka/tailwind-variants";
import { clsx } from "clsx";

export const INPUT_CLASS_NAME = tv({
  base: clsx(
    "w-full max-w-[800px] outline-none border border-grayScale-200 py-[13px] rounded-[6px]",
    // focus
    "focus:border-2 focus:border-grayScale-400",
    // disabled
    "disabled:cursor-not-allowed disabled:border-grayScale-300 disabled:bg-grayScale-100 disabled:text-base-disabled",
  ),
  variants: {
    size: {
      sm: "h-[32px] px-[12px]",
      md: "h-[40px] px-[16px]",
      lg: "h-[50px] px-[16px]",
    },
    error: {
      true: "enabled:border-functional-danger hover:enabled:bg-functional-danger-light focus:border focus:bg-functional-danger-light",
      false: "hover:enabled:border-grayScale-400",
    },
  },
  defaultVariants: {
    size: "md",
    error: false,
  },
});
